<template>
	<div style="padding-top: 20px">
		<AnswerMarking :markingClass="markingClass" style="top: 15px" />
		<div v-html="question"></div>
		<!-- <v-runtime-template :template="question"></v-runtime-template> -->
	</div>
</template>

<script setup>
import {
	onMounted,
	onUnmounted,
	ref,
	defineProps,
	defineEmits,
	watch,
	isProxy,
	toRaw,
} from 'vue';
import { getQuestion_old } from '@/helpers/qbankParser/qbankDataParse';
import { useQuasar } from 'quasar';
import VRuntimeTemplate from 'vue3-runtime-template';
import AnswerMarking from './answerMarking.vue';
import { textAreaResize } from '@/helpers/utils';

const isLog = true;
const question = ref('');
let notif = null;
let notiAnswer = null;
let notiType = 'first'; // first, last,  check
let markingClass = '';

const emit = defineEmits(['onChangeProblems', 'setInputAnswer']);
const $q = useQuasar();

const props = defineProps({
	pContent: {
		default: {},
	},
	answerNoti: false,
	answer: {},
});

const onChangeAnswer = v => {
	emit(
		'setInputAnswer',
		v.target.id.replace('input_answer', ''),
		v.target.value,
		false
	);
};

const initCore = newValue => {
	if (isLog)
		console.log('-COMPO problem watch newValue-', markingClass, newValue);

	const vContent = toRaw(newValue);

	///////----input담긴_div_왼쪽_정렬----///////
	let resource = getQuestion_old(vContent.data);
	// if (isLog)console.log('-초기값-initCore-resource-', resource);
	const tt3 = 'text-align:right;';
	const rr3 = 'text-align:left;';
	resource = resource.replaceAll(tt3, rr3);

	///////----input_내부_text_align_왼쪽_정렬----///////
	const tt4 = ';text-align:center;"';
	const rr4 = ';text-align:left;"';
	resource = resource.replaceAll(tt4, rr4);
	// if (isLog)console.log('-수정완료-initCore-question-', question.value);
	question.value = resource;
	if (vContent.answer) {
		const tmpAnswer = vContent.reAnswer ? vContent.reAnswer : vContent.answer;
		if (typeof tmpAnswer == 'object') {
			setTimeout(() => {
				Object.entries(tmpAnswer).forEach(([key, value]) => {
					if (!document.getElementById('input_answer' + key)) return;
					//2023-11-20 pby null 에러 방지 적용.
					const inputAnswerObj = document.getElementById(
						'input_answer' + key
					).value;
					//2024-02-07 ljs 하이라이팅 후 답 입력 시 2000자 제한
					if (inputAnswerObj !== null || inputAnswerObj !== value) {
						document.getElementById('input_answer' + key).value = value.slice(
							0,
							2000
						);
					} else {
						console.log(
							'inputAnswerObj : obj null exeption : input_answer' + key
						);
					}
				});
			}, 100);
			setTimeout(() => {
				const item = document.querySelectorAll('.input_answers');
				item.forEach(target => {
					// target.setAttribute('readonly', true);
					target.removeEventListener('keyup', onChangeAnswer);
					target.addEventListener('keyup', onChangeAnswer);
					target.removeEventListener('change', onChangeAnswer);
					target.addEventListener('change', onChangeAnswer);
					// target.removeEventListener('keyUp', onChangeAnswer);
					// target.addEventListener('keyUp', onChangeAnswer);
				});
				textAreaResize();
			}, 100);
		}
		if (Array.isArray(tmpAnswer) && tmpAnswer.length > 0) {
			tmpAnswer.map(i => {
				setTimeout(() => {
					if (!document.getElementById('choiceList_' + i)) return;
					document.getElementById('choiceList_' + i).checked = true;
				}, 100);
			});
		}
	}
	if (vContent.result) {
		markingClass = 'marking-' + vContent.result.marking;
		if (vContent.result.marking !== 'halfWrong') {
			setTimeout(() => {
				const item = document.querySelectorAll('.input_answers');
				item.forEach(target => {
					target.removeEventListener('keyup', onChangeAnswer);
					target.removeEventListener('change', onChangeAnswer);
					target.setAttribute('readonly', true);
				});
				textAreaResize();
			}, 200);
		}
	} else {
		markingClass = '';
	}

	if (isLog)
		console.log(
			'-COMPO problem markingClass vContent.result-',
			markingClass,
			vContent.result
		);
};

watch(
	() => props.pContent,
	newValue => {
		initCore(newValue);
	}
);

watch(
	() => props.answer,
	newValue => {
		// const questionHeader = JSON.parse(JSON.stringify(newValue));
		const pAnswer = toRaw(newValue);
		if (pAnswer) {
			if (typeof pAnswer == 'object') {
				Object.entries(pAnswer).forEach(([key, value]) => {
					if (!document.getElementById('input_answer' + key)) return;
					if (document.getElementById('input_answer' + key).value !== value) {
						document.getElementById('input_answer' + key).value = value;
					}
				});
			}
			if (Array.isArray(pAnswer) && pAnswer.length > 0) {
				pAnswer.map(i => {
					setTimeout(() => {
						if (!document.getElementById('choiceList_' + i)) return;
						document.getElementById('choiceList_' + i).checked = true;
					}, 200);
				});
			}
		}
	}
);

onMounted(() => {
	initCore(props.pContent);
	// const vContent = toRaw(props.pContent);
	// question.value = getQuestion_old(vContent.data);
	// setTimeout(() => {
	//     const item = document.querySelectorAll('.input_answers');
	//     item.forEach((target) => {
	//         // target.setAttribute('readonly', true);
	//         target.removeEventListener('keydown', onChangeAnswer);
	//         target.addEventListener('keydown', onChangeAnswer)
	//         target.removeEventListener('change', onChangeAnswer);
	//         target.addEventListener('change', onChangeAnswer)
	//         // target.removeEventListener('keyUp', onChangeAnswer);
	//         // target.addEventListener('keyUp', onChangeAnswer);
	//     })
	//     textAreaResize();
	// }, 100)
	// if (vContent.answer && vContent.answer.length > 0) {
	//     vContent.answer.map(i => {
	//         setTimeout(() => {
	//             document.getElementById('choiceList_' + i).checked = true;
	//         }, 100);
	//     })
	//     notiType = props.pContent?.problemNo === 1 ? 'first' : props.pContent?.problemNo === 4 ? 'last' : '';
	//     if (notif === null) {
	//         notif = $q.notify({
	//             group: false,
	//             timeout: 0,
	//             message: '',
	//             multiLine: true,
	//             // color: 'secondary',
	//             classes: 'force-inlinie',
	//             position: 'bottom-right',
	//             actions:
	//                 notiType === 'check' ? [{ label: '정답 확인', icon: 'arrow_back_ios', color: 'yellow', handler: () => { emit('onChangeProblems', 'check'); } }] :
	//                     notiType === 'last' ? [{ label: '이전문제', icon: 'arrow_back_ios', color: 'yellow', handler: () => { emit('onChangeProblems', 'prev'); } }] :
	//                         notiType === 'first' ? [{ label: '다음문제', iconRight: 'arrow_forward_ios', color: 'yellow', handler: () => { emit('onChangeProblems', 'next'); } }] : [
	//                             { label: '이전문제', icon: 'arrow_back_ios', color: 'yellow', handler: () => { emit('onChangeProblems', 'prev'); } },
	//                             { label: '다음문제', iconRight: 'arrow_forward_ios', color: 'yellow', handler: () => { emit('onChangeProblems', 'next'); } }
	//                         ]
	//         })
	//     }
	// }

	// if (inputboxIds.value > 1) {
	//     setTimeout(() => {
	//         const item = document.querySelectorAll('.input_answers');
	//         item.forEach((target) => {
	//             target.removeEventListener('keydown', onChangeAnswer);
	//             target.addEventListener('keydown', onChangeAnswer)
	//         })
	//     }, 500)
	// }
});

onUnmounted(() => {
	//
	if (notif) {
		notif();
		notif = null;
	}
	if (notiAnswer) {
		notiAnswer();
		notiAnswer = null;
	}
});
</script>

<style lang="scss" scoped>
.template {
	&__no {
		margin: 0px 13px;
	}
}

::v-deep input {
	// width: 500px;
	// height: 32px;
	// font-size: 15px;

	border: 1px solid rgb(233, 233, 233);
	border-radius: 5px;
	outline: none;
	margin: 0px 5px;
	max-width: 100%;
	// 프리버전 테스트요청사항 21번 - 모든 입력 박스는 좌측부터 입력되도록 프론트에서 일괄 적용이 필요합니다. 확인 부탁드립니다.
	text-align: left;
	padding: 0px 10px;
}

::v-deep textarea {
	// width: 500px;
	// height: 32px;
	// font-size: 15px;

	border: 1px solid rgb(233, 233, 233);
	border-radius: 5px;
	outline: none;
	margin: 0px 5px;
	max-width: 100%;
}

::v-deep p {
	margin: 0px;
}

.radio {
	&__wrap {
		grid-template-columns: repeat(2, size(120));
		grid-template-rows: repeat(2, size(120));
	}
}

.direction__frame {
	border: 1px solid;
	padding: 10px;
	font-size: size(12);
}

.distracter {
	margin-top: size(16);
	counter-reset: number;

	.checkbox {
		display: block;
		position: relative;
		width: 100%;
		min-height: size(55);
		margin-bottom: size(20);
		background: white;
		border-radius: size(10);
		border-bottom: size(5) solid #eef3f5;
		box-shadow: 0 size(1) size(5) 0 rgba(64, 87, 1, 0.15);
		font-size: size(17);
		font-weight: 500;

		&__wrap {
			&.arrange2 {
				display: flex;
				flex-wrap: wrap;
				margin: size(-10);

				.checkbox {
					width: calc(100% / 2 - #{size(20)});
					margin: size(10);
				}
			}

			&.arrange3 {
				display: flex;
				flex-wrap: wrap;
				margin: size(-10);

				.checkbox {
					width: calc(100% / 3 - #{size(20)});
					margin: size(10);
				}
			}

			&.horizontal {
				display: flex;
				margin: size(-10);

				.checkbox {
					margin: size(10);
				}
			}

			.card-item {
				margin-right: 10px;
				@include center-element;
			}
		}

		&__label {
			// display: block;
			display: inline-flex;
			align-items: center;
			position: relative;
			width: 100%;
			// padding: size(16) size(10) size(16) size(32);
			padding: size(16) size(10) size(16) size(10);
			min-height: size(55);
			line-height: 1.31;
			background: white;
			border-radius: size(10);

			&:before {
				// counter-increment: number;
				// content: counter(number);
				display: inline-flex;
				justify-content: center;
				align-items: center;
				position: absolute;
				top: size(16);
				left: size(10);
				width: size(14);
				height: size(14);
				margin-right: size(5);
				border: size(1) solid #000;
				border-radius: 100%;
				font-size: size(12);

				& + u {
					margin-left: 0;
				}
			}
		}

		input {
			display: none;
			// 모든 인풋박스 좌측정렬로 변경 요청
			text-align: left !important;

			&:checked {
				& + .checkbox__label {
					box-sizing: border-box;

					&:after {
						content: '';
						display: block;
						width: 100%;
						height: 100%;
						border: size(2.5) solid #3a3a3a;
						position: absolute;
						left: 0;
						top: 0;
						box-sizing: border-box;
						border-radius: 9px;
					}

					&.correct {
						border-color: #00a7ff;
						color: #00a7ff;

						&:before,
						&:after {
							border-color: #00a7ff;
							color: #00a7ff;
						}

						::v-deep u {
							color: #00a7ff;
						}
					}

					&.wrong {
						border-color: #ff0000;
						color: #ff0000;

						&:before,
						&:after {
							border-color: #ff0000;
							color: #ff0000;
						}

						::v-deep u {
							color: #ff0000;
						}
					}
				}
			}
		}
	}
}

.template {
	.direction {
		&__thumb {
			padding: size(12.5) 0;
			border: none;
		}

		&__textbox {
			line-height: 1.4;

			::v-deep > div {
				min-height: size(17);
			}
		}
	}
}

::v-deep .textbox_inputImg {
	vertical-align: middle;
}

.disableTouch {
	touch-action: none;
	pointer-events: none;
}
</style>
